module.exports = __webpack_public_path__ + "static/media/offlineBg.fbf0d220.png";